module.exports = __webpack_public_path__ + "img/item1-1.83f59a0f.jpg";